import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PaymentMethodsPage } from '@/features/billing/payment-methods-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Moyens de paiement du locataire (lot L01) : favori, suppression, ajout. */
export const Route = createFileRoute('/$tenant/billing/payment-methods/')({ component: PaymentMethodsRoute });

function PaymentMethodsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="paymentMethods"
      crumbs={[{ label: t('nav.items.paymentMethods') }]}
    >
      <PaymentMethodsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
